/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';
import { FaUserAlt } from 'react-icons/fa';
import './styles.scss';

const EpCard = ({
  cardTitle, cardHeader, cardBody, cardFooter,
}) => (
  <div className="card">
    <div className="card-header card__header">
      <div className="card__header-title">
        <FaUserAlt className="card__header-title-icon" />
        <span className="card__header-title-text">{cardTitle}</span>
      </div>
      {cardHeader !== undefined && (
        <>
          { cardHeader }
        </>
      )}
    </div>
    <div className="card-body card__body">
      {cardBody}
    </div>
    {cardFooter !== undefined && (
      <div className="card-footer card__footer">
        {cardFooter}
      </div>
    )}
  </div>
);

export default EpCard;

EpCard.defaultProps = {
  cardHeader: undefined,
  cardFooter: undefined,
};

EpCard.propTypes = {
  cardTitle: PropTypes.string.isRequired,
  cardHeader: PropTypes.element,
  cardFooter: PropTypes.element,
  cardBody: PropTypes.element.isRequired,
};
